<template>
  <div id="my-password-change-update reverse-mobile" class="row">
    <div class="col-12 col-md-3">
      <UserMenu></UserMenu>
    </div>
    <div class="col-12 col-md-9">
      <h3>Reset my password</h3>
      <div class="row">
        <div class="col-12">
          <div class="alert alert-success" v-if="passwordSent">
            <strong>Success!</strong> We have sent you an email with further instructions.
          </div>
          <div class="alert alert-danger" v-if="errorFound">
            <strong>Whoops!</strong> We couldn't find that email address.
          </div>
          <form @submit.prevent="updatePassword">
            <div class="form-group">
              <div id="auth-messages" class="auth-messages"></div>
              <label for="newPassword">New Password</label>
              <input
                type="password"
                class="form-control"
                id="newPassword"
                aria-describedby="newPassword"
              />
              <label for="confirmPassword">Confirm Password</label>
              <input
                type="password"
                class="form-control"
                id="confrimPassword"
                aria-describedby="confirmPassword"
              />
            </div>
            <button id="sendButton" type="submit" class="btn btn-primary">Change Password</button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserMenu from "../components/UserMenu";
import UserService from "../services/user.service";
import router from "../router";
export default {
  name: "MyPasswordChangeUpdate",
  components: {
    UserMenu
  },
  data() {
    return {
      passwordSent: false,
      errorFound: false,
      loading: false
    };
  },
  methods: {
    updatePassword: function() {
      //   let userName = document.getElementById("inputEmail").value;
      //   UserService.requestPasswordReset(userName)
      //   .then(()=> {
      //     this.passwordSent = true;
      //     this.errorFound = false;
      //   }).catch(() => {
      //     this.errorFound = true;
      //     this.passwordSent = false;
      //   }).finally(() => {
      //   })
    }
  }
};
</script>

<style scoped>
.auth-messages {
  display: none;
}
</style>
